<template>
    <div>

        <div v-if="init" class="pb-16">

            <div class="mkt-preview">

                <div class="mx-8">
                    <table class="mkt-user-detail">
                        <tr>
                            <td style="width: 150px">Společnost:</td>
                            <td class="mkt-user-cell"><strong>E Zilly CZ, s.r.o.</strong></td>
                            <td rowspan="2">
                                <img src="../assets/img/ezilly-logo.png" alt="Ezilly">
                            </td>
                        </tr>
                        <tr>
                            <td>Období:</td>
                            <td class="mkt-user-cell capitalize">{{ monthName }} / {{ date.year }}</td>
                        </tr>
                    </table>
                </div>

            </div>
                
            <table class="mkt-preview-table">
                <thead>
                    <tr>
                        <th class="mkt-td-border-bottom mkt-td-border-right"></th>
                        <th class="mkt-td-border-bottom mkt-td-border-right">Den</th>
                        <th class="mkt-cell-width mkt-td-border-bottom" v-for="i in numOfDaysInMonth" :key="i">
                            {{ i }}
                        </th>
                        <th colspan="2" class="mkt-td-border-bottom mkt-td-border-left">Celkem</th>
                    </tr>
                </thead>
                
                <tbody>
                    <template v-for="(marktime, index) in filteredMarktimes">
                        <tr>
                            <th rowspan="2" class="text-left pl-3 mkt-td-border-bottom mkt-td-border-right px-2">{{ getUser(marktime.user).name }}</th>
                            <th class="mkt-td-border-right">Absence</th>
                            <td class="mkt-cell-width font-bold" v-for="(day, i) in marktime.marktime" :key="i">
                                {{ getType(day.type) }}
                            </td>
                            <td class="mkt-td-border-left px-3">{{ getAbsenceHours(marktime.marktime) }}</td>
                            <td class="mkt-td-border-bottom px-4 font-bold" rowspan="2">{{ getTotalHours(marktime.marktime) }}</td>
                        </tr>
                        <tr>
                            <th class="mkt-td-border-bottom mkt-td-border-right px-2">Odpracováno</th>
                            <td class="mkt-cell-width mkt-td-border-bottom" v-for="(day, i) in marktime.marktime" :key="i">
                                <span v-if="day.timeFrom || day.timeOff">{{ total(day) }}</span>
                            </td>
                            <td class="mkt-td-border-bottom mkt-td-border-left">{{ getWorkingHours(marktime.marktime) }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>


    </div>
</template>

<script>
import { db, auth } from '@/firebase'
import { mapState } from "vuex";
import helper from '../helpers';
import moment from 'moment';

export default {
    data() {
        return {
            marktimes: null,
            date: {
                month: this.$route.params.month,
                year: this.$route.params.year
            }
        }
    },
    computed: {

        init() {
            if (this.marktimes && this.users && this.currentUser) return true
            return false
        },

        ...mapState({
            users: state => state.users,
            currentUser: state => state.user.info,
        }),

        monthName() {
            return moment({month: this.date.month}).format('MMMM');
        },

        marktimesWithNames() {
            if (this.init) {

                return this.marktimes.map(marktime => {
                    marktime.userName = this.getUser(marktime.user).name;
                    return marktime
                })
            }
        },

        numOfDaysInMonth() {
            return moment({month: this.date.month}).daysInMonth();
        },

        filteredMarktimes() {
            if (this.init) {

                var marktimes = this.marktimesWithNames;

                marktimes = marktimes.filter(marktime => {
                    var user = this.getUser(marktime.user);
                    if (user.role !== 'superadmin') return true;
                    return false;
                });

                marktimes = marktimes.sort((a, b) => {
                    return a.userName.localeCompare(b.userName);
                });

                return marktimes;
            }
        }

    },

    methods: {
        getMarktimes() {

            this.loading = true
        
            db
            .collection('marktimes')
            .where('month', '==', parseFloat(this.date.month))
            .where('year', '==', parseFloat(this.date.year))
            .onSnapshot(query => {
                var marktimes = []
                query.forEach(function (doc) {
                    var marktime = doc.data()
                    marktime.id = doc.id
                    marktime = helper.mutateMarktime(marktime)
                    marktimes.push(marktime)
                });
                this.marktimes = marktimes
            })

        },

        getType(type) {
            if (type !== '0') return type;
            return '';
        },

        getUser(uid) {            
            return this.users.find(user => user.uid === uid);
        },

        total(day) {
            return parseFloat(helper.getDuration(day)).toFixed(1);
        },

        getAbsenceHours(marktime) {
            var hours = 0;

            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;

            marktime.forEach(marktime => {
                if (marktime.type !== '0') {
                    if (marktime.type === 'SLC') {}
                    else if (marktime.type === 'D') {
                        if (marktime.halfday) hours += workingHours / 2;
                        else hours += workingHours;
                    }
                    else if (marktime.type === 'NV') hours += marktime.timeOff;
                    else {
                        hours += workingHours;
                    }
                }
                
            })

            return hours;
        },

        getWorkingHours(marktime) {
            var hours = 0;

            marktime.forEach(day => {
                if (day.timeFrom) hours += parseFloat(helper.getDuration(day));
            });

            return hours;
        },

        getTotalHours(marktime) {
            return this.getAbsenceHours(marktime) + this.getWorkingHours(marktime);
        }

    },

    created() {
        this.getMarktimes();
        if (!this.users) this.$store.dispatch('getUsers');
        if (!this.currentUser) this.$store.dispatch('user/getUser');
    }
}
</script>

<style lang="scss" scoped>
    * { 
        font-family: 'Arial', 'Helvetica', sans-serif;
    } 
    h1 {
        text-align: center;
        font-weight: normal;
    }
    h2 {
        padding:0 5rem;
        text-align: center;
        font-size: 22px;
    }
    .mkt-preview {
        margin: 2rem 0 0 0;
    }
    .mkt-cell-width {
        width: 2.8%;
    }
    .mkt-user-detail {
        margin: 0.5rem 0 1.5rem 0;
        width: 100%;
        font-size: 12px;

        .mkt-user-cell {
            border-bottom: 1px solid black;
            text-align: center;
            padding: 0 3rem;
            width: 300px;
        }
    }
    .mkt-preview-table {
        border-spacing: 0;
        width: calc(100% - 4rem);
        margin: 0 2rem;
        border: 2px solid black;

        th,td {
            border-left: 1px solid #aaa;
            border-bottom: 1px solid #aaa;
            white-space: nowrap;
            text-align: center;
            font-size: 11px;
            padding: 0.3rem 0;
        }
        tr:last-child td {
            border-bottom: 0;
        }
    }
    .mkt-overview-table {
        border-spacing: 0;
        margin: 1rem 2rem 0 2rem;
        border: 2px solid black;

        th, td {
            border-left: 1px solid #aaa;
            border-bottom: 1px solid #aaa;
            white-space: nowrap;
            padding: 0 .3rem;
            font-size: 12px;
        }
        tr:last-child td {
            border-bottom: 0;
        }
    }
    .mkt-td-center {
        text-align: center;
    }
    .mkt-vouchers-wrapper {
        display: flex;
        flex-direction: column;
        margin-left: 1rem;
    }
    .mkt-signature {
        flex: 1;
        display: flex;
        align-items: flex-end;

        td {
            padding-right: 4rem;
        }
    }
    .mkt-overview-vouchers {
        border-spacing: 0;
        margin-top: 4rem;
        border: 2px solid black;

        th, td {
            border: 1px solid #aaa;
            white-space: nowrap;
            font-size: 16px;
            padding: .5rem;
            text-align: center;
        }
    }
    .mkt-overview-wrapper {
        display: flex;
    }
    .mkt-rotate {
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        width: 20px;

        div {
            margin-left: -30px;
            margin-right: -30px; 
            transform: rotate(-90deg);
        }
    }
    .mkt-td-size-big {
        font-size: 14px !important;
    }
    .mkt-td-border-bottom {
        border-bottom: 2px solid black !important;
    }
    .mkt-td-border-right {
        border-right: 2px solid black !important;
    }
    .mkt-td-border-left {
        border-left: 2px solid black !important;
    }
    img {
        max-width: 100px;
        margin: 0 auto;
    }

    @media print {
        @page {
            size: landscape
        }

        table {
            page-break-inside: auto;
        }
        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }
        thead {
            display: table-header-group;
        }
        tfoot {
            display: table-footer-group;
        }

        .mkt-cell-width {
            font-size: 8px !important;
        }
        
        .mkt-preview-table {
            td, th {
                padding: 0.2rem 0;
            }
        }
    }
</style>